var o = Object.prototype, r = o.toString;
function e(t) {
  return r.call(t);
}
export {
  e as default
};
